import type { CardCourseTabProps } from "./CardCourseTab.types";
import {
  CONTENT_TYPE,
  LEVEL
} from "../../consts";
import type { JavaBasicDate } from "../../types";

/* eslint-disable max-len */

export const Default: CardCourseTabProps = {
  categories: ["finanza", "tecnologia"],
  coverPublicURL: "https://medias4b2sit.ispfdevelop.com/media/2023-03/01_stereotipi.jpg?VersionId=fEb_N7Hi4VLbbslJltALvWwAt6QqPUHO",
  date: [2023, 4, 23] as JavaBasicDate,
  duration: 2346,
  id: 234,
  learningObjectType: CONTENT_TYPE.BLENDED,
  learningObjectTypology: LEVEL.PATH,
  shortDescription: "Scopri come definire il tuo pubblico di riferimento, comprendere le esigenze dei tuoi clienti e adattare la tua strategia.",
  title: "Inbound Marketing",
  canAccessNow: true
};
